<script setup lang="ts">
defineProps<{
    companyPub: any
}>()

const { state } = useAppStore()
</script>

<template>
    <section class="py-12">
        <UContainer>
            <UiCompanyOverallTeshold
                :company-pub="companyPub"
            />
            <div class="mt-12">
                <div class="flex flex-wrap -mx-1.5 -my-3.5">
                    <template
                        v-for="cat in companyPub.scores"
                        :key="cat.category"
                    >
                        <div v-if="cat.category_id != 9" class="flex flex-col items-center justify-center w-1/4 px-1.5 py-3.5 flex flex-col items-start justify-start relative max-[769px]:w-1/3 max-[641px]:w-1/2">
                            <p
                                class="mb-3.5 block w-full fs-montserrat fs-sm font-semibold uppercase text-center"
                                :style="{ color: useScoreTreshold(cat.over_100).dark }"
                            >
                                <span
                                    v-if="cat.category != 'Overall'"
                                >
                                    <span class="font-semibold">
                                        {{ ` ${cat.position} ${useText(state.strings, 'sc_of')} ${cat.count_companies}` }}
                                    </span>
                                </span>
                                <span
                                    v-if="cat.category == 'Overall'"
                                >
                                    <span class="font-semibold">
                                        {{ ` ${cat.ranking} ${useText(state.strings, 'sc_of')} ${cat.total_company_count}` }}
                                    </span>
                                </span>
                            </p>
                            <div
                                class="mx-auto relative w-[210px] h-[210px] rounded-full flex items-center justify-center"
                                :style="{
                                    background: `conic-gradient(${useScoreTreshold(cat.over_100).default} ${cat.over_100}%, ${useScoreTreshold(cat.over_100).light} 0%)`,
                                }"
                            >
                                <div
                                    class="absolute top-0 left-1/2 w-[2px] h-1/2 border-l-2 border-dashed"
                                    :style="{
                                        transformOrigin: 'bottom center',
                                        transform: `translateX(-50%) rotate(${(cat.median_over_100 / 100) * 360}deg)`,
                                        borderColor: useScoreTreshold(cat.over_100).dark,
                                    }"
                                />
                                <div
                                    class="relative z-10 w-[136px] h-[136px] rounded-full flex items-center justify-center"
                                    :style="{ backgroundColor: useScoreTreshold(cat.over_100).light }"
                                >
                                    <p class="fs-2xl font-semibold font-montserrat text-center" :style="{ color: useScoreTreshold(cat.over_100).dark }">{{ cat.over_100.toFixed(0) }}%</p>
                                </div>
                            </div>
                            <p class="mt-3.5 mx-auto uppercase fs-xs text-center">
                                {{ useCategoryName(state.categories, cat.category_id) || useText(state.strings, 'sc_cat_ov') }}
                            </p>
                        </div>
                       <!--  <div
                            v-if="cat.category_id != 9"
                            class="w-1/4 px-3.5 py-3.5 flex flex-col items-start justify-start relative max-[769px]:w-1/3 max-[641px]:w-1/2"
                        >
                            <p
                                class="fs-xs"
                                :style="{ color: useScoreTreshold(cat.over_100).dark }"
                            >
                                <span
                                    v-if="cat.category != 'Overall'"
                                >
                                    <span>
                                        {{ `${useText(state.strings, 'sc_position')}:` }}
                                    </span>
                                    <span class="font-semibold">
                                        {{ ` ${cat.position} ${useText(state.strings, 'sc_of')} ${cat.count_companies}` }}
                                    </span>
                                </span>
                                <span
                                    v-if="cat.category == 'Overall'"
                                >
                                    <span>
                                        {{ `${useText(state.strings, 'sc_position')}:` }}
                                    </span>
                                    <span class="font-semibold">
                                        {{ ` ${cat.ranking} ${useText(state.strings, 'sc_of')} ${cat.total_company_count}` }}
                                    </span>
                                </span>
                            </p>
                            <div
                                class="mt-2 w-full min-h-[185px] relative rounded-[12px]"
                                :style="{
                                    backgroundColor: useScoreTreshold(cat.over_100).default,
                                }"
                            >
                                <div
                                    class="absolute top-0 left-0 w-full border-b rounded-t-[12px]"
                                    :style="{
                                        height: `${100 - cat.over_100}%`,
                                        backgroundColor: useScoreTreshold(cat.over_100).light,
                                        borderColor: useScoreTreshold(cat.over_100).dark,
                                    }"
                                />
                                <div
                                    class="absolute w-full h-[1ox] border-dashed border-t rounded-t-[12px]"
                                    :style="{
                                        borderColor: useScoreTreshold(cat.over_100).dark,
                                        top: `${cat.median_over_100}%`,
                                    }"
                                />
                                <div
                                    class="absolute top-full left-1/2 -translate-x-1/2 -translate-y-1/2 w-[70px] h-[70px] flex items-center justify-center rounded-full bg-white"
                                    :style="{
                                        color: useScoreTreshold(cat.over_100).dark,
                                    }"
                                >
                                    <svg
                                        width="43"
                                        height="33"
                                        viewBox="0 0 43 33"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M37.0612 5.98745C26.0424 9.1908 11.51 17.9106 5.82326 24.3421M33.3273 3.74394C27.1554 5.02662 23.8164 5.58311 18.8628 9.1908M12.9196 12.8812C10.4606 14.487 7.68779 17.3836 7.14397 19.4132M35.818 10.6271C29.1084 16.1565 13.2988 25.1022 10.4457 25.5807M38.9743 12.7151C38.2852 13.9305 36.6157 15.6 35.0534 16.9474M31.6764 19.1501C28.8248 21.7214 21.912 25.5456 19.9455 25.9509M17.2458 26.7813C15.6387 27.3865 12.0199 28.4886 10.402 28.0551M35.3932 1.81219C34.8139 1.65698 31.4741 1.21183 27.005 1.91574C20.3293 2.96719 11.1337 6.58245 4.85441 17.5574C3.46695 19.9825 3.16712 22.6989 2.77867 24.1486C2.49856 25.194 1.73474 25.7334 1.50167 26.6032C1.2686 27.473 1.74687 29.1549 3.63566 29.0395C5.52446 28.9241 6.39116 29.1564 7.83568 29.5434C9.28019 29.9305 12.4359 31.0532 14.847 31.1114C23.769 31.3267 39.1271 21.3897 41.5961 12.1754C41.7938 11.4373 41.839 10.5789 41.7875 9.73996C41.7176 8.60141 41.4697 7.4988 41.1834 6.78196C40.7306 5.64831 39.8575 3.78371 37.3643 2.54525C36.7961 2.26303 36.1438 2.01332 35.3932 1.81219Z"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                        />
                                    </svg>
                                </div>
                            </div>
                            <p class="mt-8 mx-auto uppercase fs-xs text-center">
                                {{ useCategoryName(state.categories, cat.category_id) || useText(state.strings, 'sc_cat_ov') }}
                            </p>
                        </div> -->
                    </template>
                </div>
            </div>
        </UContainer>
    </section>
</template>
